export enum PenaltyRunsAttributesId {
  Five = 592,
}
